import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/PostList.tsx");
